__turbopack_context__.v({
  "article": "_6K2wfW_article",
  "article__meta": "_6K2wfW_article__meta",
  "wrapper": "_6K2wfW_wrapper",
});
